export default __webpack_public_path__ + "static/media/ic_settings_16.45586872.svg";